<bxi-page [title]="'elsImport.title' | translate" [breadcrumbOptions]="breadcrumbOptions()" class="h-screen w-full">
  <bx-tab-group [fullWidth]="true">
    <bx-tab title="Tado/Dragino JSON" icon="file-05">
      <bxi-tado-dragino-import></bxi-tado-dragino-import>
    </bx-tab>
    <bx-tab title="Qundis CSV" icon="file-05">
      <bxi-qundis-import></bxi-qundis-import>
    </bx-tab>
    <bx-tab title="EI XML" icon="file-05">
      <bxi-ei-import></bxi-ei-import>
    </bx-tab>
  </bx-tab-group>
</bxi-page>
